(() => {
  const root = document.querySelector('[data-jb-bis-root]');
  if (!root) return;

  const companyId = root.dataset.companyId;
  const listId = root.dataset.listId;
  const dialog = root.querySelector('.jb-bis__dialog');
  const backdrop = root.querySelector('.jb-bis__backdrop');
  const formView = root.querySelector('[data-jb-bis-form-view]');
  const successView = root.querySelector('[data-jb-bis-success]');
  const form = root.querySelector('[data-jb-bis-form]');
  const emailInput = root.querySelector('#JbBisEmail');
  const marketingInput = root.querySelector('[data-jb-bis-marketing]');
  const variantText = root.querySelector('[data-jb-bis-variant]');
  const errorText = root.querySelector('[data-jb-bis-error]');
  const submitButton = root.querySelector('[data-jb-bis-submit]');
  let activeContext = null;
  let lastFocusedElement = null;
  let closeTimer = null;

  marketingInput.checked = root.dataset.marketingChecked === 'true';

  function selectedVariant(productInfo) {
    if (productInfo.currentVariant) return productInfo.currentVariant;
    const json = productInfo.querySelector('variant-picker [data-selected-variant]')?.textContent;
    if (!json) return null;
    try {
      return JSON.parse(json);
    } catch (_error) {
      return null;
    }
  }

  function buttonText(button, value) {
    const label = button.querySelector('.m-add-to-cart--text');
    if (label) label.textContent = value;
    else button.textContent = value;
  }

  function rememberButton(button) {
    if (button.dataset.jbBisRemembered === 'true') return;
    button.dataset.jbBisRemembered = 'true';
    button.dataset.jbBisStyle = button.classList.contains('m-button--secondary') ? 'secondary' : 'primary';
  }

  function showRestockButton(button) {
    rememberButton(button);
    button.type = 'button';
    button.disabled = false;
    button.removeAttribute('aria-disabled');
    button.classList.remove('m-button--primary');
    button.classList.add('m-button--secondary', 'jb-bis-trigger');
    buttonText(button, 'Notify Me When Back in Stock');
  }

  function restoreButton(button, variant) {
    if (button.dataset.jbBisRemembered !== 'true') return;
    button.type = 'submit';
    button.classList.remove('jb-bis-trigger', 'm-button--primary', 'm-button--secondary');
    button.classList.add(`m-button--${button.dataset.jbBisStyle || 'primary'}`);
    if (variant?.available) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      buttonText(button, button.dataset.atcText || 'Add to Cart');
    }
  }

  function syncProductInfo(productInfo) {
    const variant = selectedVariant(productInfo);
    const buttons = productInfo.querySelectorAll('button[name="add"]');
    buttons.forEach((button) => {
      if (variant && variant.available === false) showRestockButton(button);
      else restoreButton(button, variant);
    });
  }

  function syncAll() {
    document.querySelectorAll('product-info').forEach(syncProductInfo);
  }

  function productTitle(productInfo) {
    const title = productInfo.querySelector('.m-product-title, h1, [data-product-title]');
    return title?.textContent?.replace(/\s+/g, ' ').trim() || 'This item';
  }

  function openModal(button) {
    const productInfo = button.closest('product-info');
    const variant = productInfo && selectedVariant(productInfo);
    if (!productInfo || !variant || variant.available !== false) return;

    activeContext = { productInfo, variant };
    lastFocusedElement = button;
    clearTimeout(closeTimer);
    form.reset();
    marketingInput.checked = root.dataset.marketingChecked === 'true';
    errorText.hidden = true;
    errorText.textContent = '';
    formView.hidden = false;
    successView.hidden = true;

    const title = productTitle(productInfo);
    const variantName = variant.title && variant.title !== 'Default Title' ? ` — ${variant.title}` : '';
    variantText.textContent = `${title}${variantName}`;

    backdrop.hidden = false;
    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jb-bis-open');
    requestAnimationFrame(() => emailInput.focus());
  }

  function closeModal() {
    clearTimeout(closeTimer);
    backdrop.hidden = true;
    dialog.hidden = true;
    dialog.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('jb-bis-open');
    activeContext = null;
    lastFocusedElement?.focus();
  }

  async function postKlaviyo(path, payload) {
    const response = await fetch(`https://a.klaviyo.com${path}?company_id=${encodeURIComponent(companyId)}`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        revision: path === '/client/subscriptions/' ? '2026-07-15' : '2024-06-15',
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(`Klaviyo request failed (${response.status})`);
  }

  function restockPayload(email, variantId) {
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email } } },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` },
          },
        },
      },
    };
  }

  function marketingPayload(email) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } },
                },
              },
            },
          },
          custom_source: 'Back in Stock',
        },
        relationships: {
          list: { data: { type: 'list', id: listId } },
        },
      },
    };
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.jb-bis-trigger');
    if (trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal(trigger);
      return;
    }
    if (event.target.closest('[data-jb-bis-close]')) closeModal();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (dialog.hidden) return;
    if (event.key === 'Escape') closeModal();
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hidden);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!activeContext || !companyId) return;
    if (!form.reportValidity()) return;

    const email = emailInput.value.trim();
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    errorText.hidden = true;

    try {
      await postKlaviyo('/client/back-in-stock-subscriptions/', restockPayload(email, activeContext.variant.id));
      if (marketingInput.checked && listId) {
        try {
          await postKlaviyo('/client/subscriptions/', marketingPayload(email));
        } catch (marketingError) {
          console.warn('Restock alert saved, but marketing consent could not be saved.', marketingError);
        }
      }
      formView.hidden = true;
      successView.hidden = false;
      successView.focus();
      closeTimer = window.setTimeout(closeModal, 1800);
    } catch (error) {
      console.error('Back in stock subscription failed.', error);
      errorText.textContent = 'We couldn’t save that alert. Please try again.';
      errorText.hidden = false;
    } finally {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('variant:changed', () => requestAnimationFrame(syncAll));
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('load', syncAll);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('product-info') || node.querySelector?.('product-info'))))) {
      requestAnimationFrame(syncAll);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
